import { useMutation } from "@tanstack/react-query";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { deleteProjectApi } from "@/API/deleteProjectApi";
import { ShowNotification } from "@/components/ShowNotification";

export const useDeleteProject = () => {
  const { invalidateProjects } = useInvalidateQueries();

  return useMutation({
    mutationFn: (projectId: string) => deleteProjectApi(projectId),

    onError: () => {
      ShowNotification({
        title: "Error",
        message: "An error occurred while deleting the project.",
        color: "error",
      });
    },
    onSuccess: () => {
      invalidateProjects();
      ShowNotification({
        title: "Success",
        message: "Project has been deleted!",
        color: "info",
      });
    },
  });
};
